import {createAsyncThunk} from '@reduxjs/toolkit';
import {filtersApi} from 'api';
import {IBindBaseEntity} from 'models';
import {toastNotificationManager} from 'toast-notifications';
import {prefix} from './config';

export const fetchConceptsThunk: any = createAsyncThunk<IBindBaseEntity[], number[]>(
  `${prefix} fetchConcepts`,
  async (payload: number[], {rejectWithValue, dispatch}) => {
    try {
      const {parsedBody} = await filtersApi.getConcepts(payload);
      return parsedBody;
    } catch (error) {
      dispatch(
        toastNotificationManager.createErrorToastAction(
          error.parsedBody || error.statusText || 'Failed to fetch concepts. Unknown error occurred.'
        )
      );
      return rejectWithValue(error);
    }
  }
);
